import { render, staticRenderFns } from "./AiMessageBubble.vue?vue&type=template&id=59b778b9&scoped=true"
import script from "./AiMessageBubble.vue?vue&type=script&lang=js"
export * from "./AiMessageBubble.vue?vue&type=script&lang=js"
import style0 from "./AiMessageBubble.vue?vue&type=style&index=0&id=59b778b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b778b9",
  null
  
)

export default component.exports